import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import { Trans } from "react-i18next";

const styles = (theme) => ({
  page: {
    padding: 20,
  },
  buttonContainer: {
    marginTop: 30,
  },
});

export default function(WrappedComponent) {
  return withStyles(styles)(
    class extends Component {
      state = {
        nextDisabled: false,
        reindexDisabled: false,
      };
      childRef = React.createRef();

      next = () => {
        // not sure the best way to validate a child form without using refs...
        if (this.childRef.current && this.childRef.current.onSubmit) {
          this.childRef.current.onSubmit();
        } else {
          this.props.next();
        }
      };

      childNext = () => {
        this.props.next();
      };

      setNextDisabled = (nextDisabled) => {
        this.setState({ nextDisabled });
      };

      setReindexDisabled = (reindexDisabled) => {
        this.setState({ reindexDisabled });
      };

      render() {
        const { classes } = this.props;
        return (
          <Paper
            className={classes.page}
            style={{ display: this.props.show ? null : "none" }}
            elevation={this.props.isReindex ? 0 : 1}
          >
            <div>
              <WrappedComponent
                {...this.props}
                ref={this.childRef}
                next={this.childNext}
                setNextDisabled={this.setNextDisabled}
                setReindexDisabled={this.setReindexDisabled}
              />
            </div>
            {!this.props.hideButtons && (
              <div
                style={{ display: "flex" }}
                className={classes.buttonContainer}
              >
                {this.props.isEnd ? (
                  <div style={{ flex: 1, justifyContent: "flex-end" }}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.props.restart}
                      style={{ float: "right" }}
                      id="ks-restart-button"
                    >
                      {this.props.restartText ? (
                        this.props.restartText
                      ) : (
                        <Trans i18nKey="create_ks_create_another" />
                      )}
                    </Button>
                  </div>
                ) : (
                  <>
                    <div style={{ flex: 1, justifyContent: "flex-start" }}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.props.back}
                        id={this.props.show ? "ks-back-button" : null}
                      >
                        <Trans i18nKey="global_back" />
                      </Button>
                    </div>
                    <div style={{ flex: 1, justifyContent: "flex-end" }}>
                      {this.props.showReindexButtons && (
                        <>
                          <Button
                            variant="contained"
                            color="primary"
                            disabled={this.state.reindexDisabled}
                            onClick={() => this.props.reindex(false)}
                            style={{ float: "right", marginLeft: 5 }}
                            id="ks-save-reindex-button"
                          >
                            <Trans i18nKey="create_ks_save_reindex" />
                          </Button>
                          <Button
                            variant="contained"
                            color="primary"
                            disabled={this.state.reindexDisabled}
                            onClick={() => this.props.reindex(true)}
                            style={{ float: "right", marginLeft: 5 }}
                            id="ks-save-full-reindex-button"
                          >
                            <Trans i18nKey="create_ks_save_full_reindex" />
                          </Button>
                        </>
                      )}
                      <Button
                        variant="contained"
                        color="primary"
                        disabled={this.state.nextDisabled}
                        onClick={() => this.next()}
                        style={{ float: "right" }}
                        id={this.props.show ? "ks-next-button" : null}
                      >
                        {this.props.nextText ? (
                          this.props.nextText
                        ) : (
                          <Trans i18nKey="global_next" />
                        )}
                      </Button>

                      {this.props.showSkipButton && (
                        <>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => this.props.next()}
                            id="ks-skip-button"
                            style={{ float: "right", marginRight: 5 }}
                          >
                            <Trans i18nKey="global_skip" />
                          </Button>
                        </>
                      )}
                    </div>
                  </>
                )}
              </div>
            )}
          </Paper>
        );
      }
    }
  );
}
